import React from 'react'
import PropTypes from 'prop-types';

class ErrorPage extends React.Component {
  static propTypes = {
    error: PropTypes.object.isRequired
  };

  render () {
    const { error } = this.props
    if (process.env.NODE_ENV !== 'production') {
      return (
        <div>
          {this.renderErrorMessage()}
          {error && error.message && <p>{error.message}</p>}
          <pre>{error.stack}</pre>
          {this.renderRecommendation(error)}
        </div>
      )
    }

    return (
      <div>
        {this.renderErrorMessage(error)}
        {this.renderRecommendation(error)}
      </div>
    )
  }

  renderRecommendation (error) {
    return <div>
      {error && <hr />}
      {error && error.recommendation && <p>{error.recommendation}</p>}
      {error && !error.recommendation && <p>Please <a href={'https://www.allangray.co.za/contact-us/'}>contact us</a> about this.</p>}
    </div>
  }

  renderErrorMessage () {
    return <div>
      <h2>There seems to be a problem on this page.</h2>
    </div>
  }
}

export { ErrorPage as ErrorPageWithoutStyle }
export default ErrorPage
